import {accordionToggle} from "./modules/accordion";
import {languageToggler} from "./modules/language-selector-toggler";
import {modalTrigger} from "./modules/modal";
import {countDownTimer} from "./modules/countdown";
import {countrySelection} from "./modules/country-selection";
import {codeSubmit} from "./modules/code-submit";
import {userForm} from "./modules/password-change-form";
import {afterPasswordChange} from "./modules/after-password-change";
import {winnerTable} from "./modules/winners-tabs";


languageToggler();
accordionToggle();
modalTrigger();
countDownTimer();
countrySelection();
codeSubmit();
userForm();
afterPasswordChange();
winnerTable();
